import type { FaireProductEntity } from "../../entity_types/product";

export const p_cp5mznbeap: FaireProductEntity = {
  token: "p_cp5mznbeap",
  type: "product",
  name: "Hanging Storage Basket",
  brandToken: "b_6jbk8zuc",
  brandName: "Amsha",
  imageUrl: "https://cdn.faire.com/fastly/1a27ed5cb667cde1a35378db17f2c5fca4d2a75895c64598b2e9db6915fc5176.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a6a9e704c9353fe17332cac4a61742cdd8754071c79fd490b0a8a8744e5ca9a8.jpeg",
    "https://cdn.faire.com/fastly/b9c12a9205b6da907e535a38841b5cd32e8440230a6c9d5003215c4b37ca58c4.jpeg",
    "https://cdn.faire.com/fastly/4b5aa2b6525102469fbb9df1b1b72baa83bd23cb14642dd4a22dac14be9d6815.jpeg",
    "https://cdn.faire.com/fastly/c8e2c65c6b7729bfffea8d09593828f0db948cf411f4a8d729e68b7683d14bb6.jpeg",
    "https://cdn.faire.com/fastly/f78b7d6818cab559d31994d060f699b8891024848d19ff738e750fe2f683aa35.jpeg",
    "https://cdn.faire.com/fastly/4e042767b1e7a99f5cd688ab3f10c38ec94abab780907107b54268feca1fcb74.jpeg",
    "https://cdn.faire.com/fastly/3ed8624365b9d515517c309ab275f0a302b7c78d1a9439fb7ec8dc2e249373ab.jpeg",
    "https://cdn.faire.com/fastly/e975bd345640da4a70369feb2b902a3cf741ee662f4ff590665cc539e1fddefd.jpeg",
    "https://cdn.faire.com/fastly/6d05880b20995f40ceb69290d90c788bb0ba6767d6285f002e8872966bfb3b59.jpeg",
    "https://cdn.faire.com/fastly/059073e9e3f885a49b6b92e46f82e3c1ce5103f765b82a8c42ae8361b23255ad.jpeg",
    "https://cdn.faire.com/fastly/5fdce218670d27e5c6d54ec6a61b0b9d1e95e9bed94c99cc787bddcb3a447a22.jpeg",
    "https://cdn.faire.com/fastly/77d16eaa1b6f35f688aaf547e067877e37f32406b94023a7694d0beba3f5dabf.jpeg",
    "https://cdn.faire.com/fastly/fb407095033a678d4d7cbda85a12f3b396c77466658e81ca243f258b9cb5fcd7.jpeg",
    "https://cdn.faire.com/fastly/306d2d51dd2c0a76c504c2c16cf836a6c938279201b399d703e93cf45cad8599.jpeg",
    "https://cdn.faire.com/fastly/1334a0e730e4ccd1776751c5b53c028054e1e52eba55faf4c576cd4ada1ee7f7.jpeg",
    "https://cdn.faire.com/fastly/dbf6a2eb35c6f3d9e4ecb75ee2e323e3ce26f9fc8d7bb6b9ae41d8b2ced161ac.jpeg",
    "https://cdn.faire.com/fastly/8923e18281d29170efcb6be5bc0a9b21a1a39ac042537ed16ef4de32e2e01ecf.jpeg"
  ],
  priceDollars: 19,
  description: "These sisal, woven baskets are handmade by a weaving cooperative in southeastern Kenya. The women hand-dye the sisal fibers and weave them into these beautiful works of art. This basket is great for wall storage in your bathroom, pantry, bedroom, or playroom! You can also display dried flowers in it.\n\nApproximately 6\" wide x 10\" tall.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:17.933Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
